import { BaseService } from '@services/BaseService';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { EscrowOfficerViewModel, OfficerSearchViewModel } from '@models/EscrowOfficer';
import { EscrowOfficeViewModel, OfficeSearchViewModel } from '@models/EscrowOffice';

class EscrowService extends BaseService {
  constructor() {
    super('escrow');
  }

  getOfficer(id: number) {
    return this.fetch<EscrowOfficerViewModel>(`officer/${id}`, {
      method: 'GET'
    });
  }

  saveOfficer(officer: EscrowOfficerViewModel) {
    return this.fetch<number>('officer', {
      method: 'POST',
      body: JSON.stringify(officer)
    });
  }

  getOfficerTypes(): Promise<OptionsViewModel[]> {
    return this.fetch<OptionsViewModel[]>('officer/types', {
      method: 'GET'
    });
  }

  getOfficerStatuses() {
    return this.fetch<OptionsViewModel[]>('officer/statuses', {
      method: 'GET'
    });
  }

  searchOffices(query: string, id: number) {
    return this.fetch<PageViewModel<OfficeSearchViewModel>>('office/search', {
      method: 'POST',
      body: JSON.stringify({ id: id, query: query })
    });
  }

  searchOfficesFull(query: string | null, pageSize?: number, page?: number, orderBy?: string, orderDirection?: string) {
    return this.fetch<PageViewModel<OfficeSearchViewModel>>('office/search', {
      method: 'POST',
      body: JSON.stringify({
        query: query,
        pageSize: pageSize,
        pageNumber: page,
        orderBy: orderBy,
        orderDirection: orderDirection
      })
    });
  }

  searchOfficers(query: string, id: number) {
    return this.fetch<PageViewModel<OfficerSearchViewModel>>('officer/search', {
      method: 'POST',
      body: JSON.stringify({ id: id, query: query })
    });
  }

  searchOfficersFull(
    query: string | null,
    pageSize?: number,
    page?: number,
    orderBy?: string,
    orderDirection?: string
  ) {
    return this.fetch<PageViewModel<OfficerSearchViewModel>>('officer/search', {
      method: 'POST',
      body: JSON.stringify({
        query: query,
        pageSize: pageSize,
        pageNumber: page,
        orderBy: orderBy,
        orderDirection: orderDirection
      })
    });
  }

  saveOffice(model: EscrowOfficeViewModel) {
    return this.fetch<number>('office', {
      method: 'POST',
      body: JSON.stringify(model)
    });
  }

  getOffice(id: number) {
    return this.fetch<EscrowOfficeViewModel>(`office/${id}`, {
      method: 'GET'
    });
  }

  getOfficeGroups() {
    return this.fetch<OptionsViewModel[]>('office/groups', {
      method: 'GET'
    });
  }

  getOfficeStatuses() {
    return this.fetch<OptionsViewModel[]>('office/statuses', {
      method: 'GET'
    });
  }

  getOfficersForOffice(officeId: number) {
    return this.fetch<OptionsViewModel[]>(`office/${officeId}/simpleOfficers?active=true`, {
      method: 'get'
    });
  }

  getOfficersForOfficeDetail(officeId: number) {
    return this.fetch<OfficerSearchViewModel[]>(`office/${officeId}/officers?active=true`, {
      method: 'get'
    });
  }
}

export const escrowService = new EscrowService();



// WEBPACK FOOTER //
// ./src/_services/EscrowService.ts